import axios from "axios"
import host_config from '../config'
let instance = axios.create()
//超时配置
instance.defaults.timeout = 10000;
//header设置
instance.defaults.headers.common['Accept'] = 'application/json'


//----------取消（上次）重复请求设置------------
class ajaxQueueManage {
  constructor() {
    this.queue = []
    this.include_host = ['http://qmovie.fanink.cn/api/v1/movies']
    // axios内置的中断ajax的方法
    // this.cancelToken = instance.CancelToken
  }
  getToken(config) {
    // console.log(config)
    // 拼接请求的url和方法，
    let token = undefined
    //1.获取电影数据接口，同样的 url+方法+indicator指标 可以视为相同的请求
    if (config.url === 'http://qmovie.fanink.cn/api/v1/movies') {
      token = `${config.url}_${config.method}_${config.data.indicator}`
    }
    //3.同样的url+方法可以视为相同的请求
    return token
  }
  addQueue(item) {
    this.queue.push(item)
  }
  removeQueue(config) {
    // 中断重复的请求，并从队列中移除
    for (let i = 0, size = this.queue.length; i < size; i++) {
      const task = this.queue[i];
      if (task && task.token === this.getToken(config)) {
        task.cancel('cancel');
        this.queue.splice(i, 1);
      }
    }
  }
}
// 请求队列
// const queue = [];
//不需要去重的请求
// const exclude_host = [`${host_config.movie_host}/api/v1/surveys/crowds/sub`, `${host_config.movie_host}/api/v1/movies`]
// const exclude_host = []
// axios内置的中断ajax的方法
// const cancelToken = instance.CancelToken;
// 拼接请求的url和方法，同样的url+方法可以视为相同的请求
// const getToken = (config) => {
//   console.log(config)
//   return `${config.url}_${config.method}`
// }
// 中断重复的请求，并从队列中移除
// const removeQueue = (config) => {
//   for (let i = 0, size = queue.length; i < size; i++) {
//     const task = queue[i];
//     if (task && task.token === getToken(config)) {
//       task.cancel();
//       queue.splice(i, 1);
//     }
//   }
// }
//-------------------------------------------

window.addEventListener("unhandledrejection", event => { });
export { instance, ajaxQueueManage }